import axios, { AxiosResponse } from 'axios';
import { searchUrl } from 'findem-helpers';

export interface MatchesPayload {
  joid?: string;
  sandbox?: boolean;
  prids?: string[];
  to_match?: string[];
  [key: string]: any;
}

export interface MatchesResponse {
  data: any;
}

const MatchesAPI = {
  makeMatchesAnalyseAPICall: async (payload: MatchesPayload): Promise<AxiosResponse<any>> => {
    return axios.post(`${searchUrl}/pub/api/matches_analyze`, payload, { withCredentials: true });
  },

  makeMatchesAnalyseV2APICall: async (payload: MatchesPayload): Promise<AxiosResponse<any>> => {
    return axios.post(`${searchUrl}/pub/api/matches_analyze_v2`, payload, { withCredentials: true });
  },

  makeMultiMatchesAPICall: async (payload: MatchesPayload): Promise<AxiosResponse<any>> => {
    return axios.post(`${searchUrl}/pub/api/multi_matches`, payload, { withCredentials: true });
  },

  makeMultiMatchesV2APICall: async (payload: MatchesPayload): Promise<AxiosResponse<any>> => {
    return axios.post(`${searchUrl}/pub/api/multi_matchesV2`, payload, { withCredentials: true });
  },

  makeMatchesAPICall: async (payload: MatchesPayload): Promise<AxiosResponse<any>> => {
    return axios.post(`${searchUrl}/pub/api/matches`, payload, { withCredentials: true });
  },

  makeMatchesV2APICall: async (payload: MatchesPayload): Promise<AxiosResponse<any>> => {
    return axios.post(`${searchUrl}/pub/api/v2/matchesV2`, payload, { withCredentials: true });
  },

  makeMatchesLiteAPICall: async (payload: MatchesPayload): Promise<AxiosResponse<any>> => {
    return axios.post(`${searchUrl}/pub/api/matches_lite`, payload, { withCredentials: true });
  },

  makeMatchesLiteV2APICall: async (payload: MatchesPayload): Promise<AxiosResponse<any>> => {
    return axios.post(`${searchUrl}/pub/api/matches_lite_v2`, payload, { withCredentials: true });
  },
};

export default MatchesAPI;
